import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';

import { catchError, throwError } from 'rxjs';

/**
 * Global HTTP error interceptor.
 *
 * Handles 401 Unauthorized responses by dispatching the `authTokenExpiryHandle`
 * custom document event, which triggers reauthentication in `PageIntroComponent`.
 * All other errors are re-thrown for downstream handlers.
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        document.dispatchEvent(new CustomEvent('authTokenExpiryHandle'));
      }
      return throwError(() => error);
    }),
  );
};
